/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[product-media="slider"]',
      thumbs: '[product-media="thumbs"]',
      mediaItem: '[data-media-id]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 0,
          watchOverflow: true,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.slider__arrow.arrow-left'),
            nextEl: this.querySelector('.slider__arrow.arrow-right'),
          },
          autoplay: this.hasAttribute('slider-autoplay')
            ? {
                delay: this.getAttribute('slider-autoplay'),
              }
            : false,
          on: {
            slideChange: function () {
              // Pause video in the previous slide
              const previousSlide = this.slides[this.previousIndex];
              const current = this.slides[this.activeIndex];
              const currentMedia = current.querySelector('.deferred-media');
              const video = previousSlide.querySelector('video');

              if (video) {
                video.pause();
              }

              if (!currentMedia) {
                return;
              }

              if (currentMedia.hasAttribute('loaded')) {
                currentMedia.querySelector('video')?.play();
                return;
              }

              currentMedia.querySelector('button')?.click();
              this.updateAutoHeight(400);
            },
          },
        },
        thumbs: {
          initialSlide: this.selectedMediaIndex,
          slidesPerView: 'auto',
          spaceBetween: 16,
          touchEventsTarget: 'container',
          freeMode: true,
          allowTouchMove: true,
        },
      },
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs)
      return;

    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
      autoScrollOffset: 1,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }
}

customElements.define('product-media', ProductMedia);
